import { WorkspaceApiKey } from '@/apis';
import { SpotlightStageScroll } from './components/SpotlightStageScroll';

import type { Shell } from '@/apilib';

export const bootstrapSpotlightStage = (shell: Shell) => {
  const workspaceAPI = shell.getAPI(WorkspaceApiKey);
  workspaceAPI.contributeStageComponent(SpotlightStageScroll);
};
